import {
getRequest,
} from "../methods/index.js"

export const DataApi = {
    getpolicy : async ()=> getRequest ("/manage-cms"),
    getTerms : async ()=> getRequest("/manage-cms"),
    getFaqs : async ()=> getRequest("/manage-cms/faqs")

  
 }